import { render } from "./ProcessSteps.vue?vue&type=template&id=4b99e152&scoped=true"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"

import "./ProcessSteps.vue?vue&type=style&index=0&id=4b99e152&scoped=true&lang=css"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b99e152"]])

export default __exports__